import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FilterWrap from "components/htmlElements/FilterWrap";
import { useReports } from "hooks/useReports";
import Select from "react-select";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import { UserRole } from "components/Reports/reportAssets/assets";
import { useTranslation } from "react-i18next";
import { tUserRole } from "i18n/enums";
import CustomOption from "./assets/CustomOption";
import DropdownIndicator from "./assets/DropdownIndicator";
import { selectControlsProps } from "./assets/selectControlsProps";
import "./selectReusable.scss";

const SelectReusableControl = ({
  optionVal,
  onChange: _onChange,
}: selectControlsProps) => {
  const [filters, setFilters] = useState<any>(null);
  // Subscribe to language changes so the selected-role label reflows on switch.
  const { i18n } = useTranslation();
  const { setselectedRole } = useReports();
  const selectedRole = useGetUserData(LocalStorageKey.SelectedRole);
  const navigate = useNavigate();
  const location = useLocation();
  const locationString = useLocationForReportType();
  const isMessagesScreen = locationString === "followup-messages";
  const isControlCenterPath = locationString === "control-center";
  const isInProgressPath = locationString === "inprogress";
  const isInProgressInsideReportPath =
    locationString === "inprogressInsideReport";

  const inProgressRegex = /^\/reports\/inprogress\/\d+$/;
  const followUpRegex = /^\/reports\/followup\/\d+$/;
  const handleFilterChange = (propName: keyof any, value: number) => {
    const newFilters = { ...filters, [propName]: value };
    setFilters(newFilters);
    _onChange(newFilters);
  };

  const selectProps = {
    // Resolve the selected-role label at render so it reflects the current
    // language (the persisted localStorage label is login-time only).
    defaultValue: selectedRole
      ? { ...selectedRole, label: tUserRole(selectedRole.value) }
      : selectedRole,
    options: optionVal,
    isRtl: true,
    isSearchable: false,
    closeMenuOnSelect: true,
    components: { DropdownIndicator, Option: CustomOption },
    className: "react-select-container",
    classNamePrefix: "react-select",
    onChange: (selectedOption: any) => {
      setselectedRole(selectedOption);
      selectedOption && handleFilterChange("type", selectedOption.value);

      if (
        selectedOption.value === UserRole.SENIOR_WATCH &&
        (isInProgressPath || isInProgressInsideReportPath)
      ) {
        navigate("/reports/followup");
        return;
      }
      if (
        inProgressRegex.test(location.pathname) ||
        followUpRegex.test(location.pathname)
      ) {
        navigate(-1);
      }
      if (isControlCenterPath || isMessagesScreen) {
        selectedOption.value !== UserRole.SENIOR_WATCH
          ? navigate("/reports/inprogress")
          : navigate("/reports/followup");
      }
    },
  };

  return (
    <FilterWrap className="filterWrap">
      <div className="customDropdown">
        {/* key on language so react-select re-applies defaultValue (uncontrolled)
            and the selected-role label reflows when the language switches */}
        <Select key={i18n.resolvedLanguage} {...selectProps} />
      </div>
    </FilterWrap>
  );
};

export default SelectReusableControl;
